import ListCollection from 'types/redux/ListCollection';

import Job from 'models/Job';
import User from 'models/User';

import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Translations {
    zeroState: {
        title: string;
        subtitle: string;
        titleScrollButton: string;
        titleSaveButton: string;
        titleSavedButton: string;
        titleClearFiltersButton?: string;
    }
}
export interface Props {
    collection: ListCollection<Job>;
    onSaveJobFavourites: (id: string, jobCityId: string) => any;
    onSaveJobSearchQuery: () => any;
    onClearFilters: () => void;
    hasActiveFilters: boolean;
    buttonProps: {
        save: ButtonProps;
        road: ButtonProps;
    }
    translations: Translations;
    onChangePage: Function;
    savedSearch: boolean,
    isLoaded?: boolean,
    profile?: User;
}

Component.defaultProps = {};

export default Component;